import React, { useContext } from "react";
import { Button } from "@rneui/themed";
import { Oidc, RegistrationContext } from "../context";
import { PlaybackEvent, PlaybackEventEmitter, useJWT } from "@annunciate/core";
export const LogInLogOutButton = (props) => {
    const jwt = useJWT();
    const ctx = useContext(Oidc);
    const regCtx = useContext(RegistrationContext);
    const isLoggedIn = jwt !== undefined ? true : false;
    const redirectUri = typeof window === 'undefined'
        ? undefined
        : window.location.href;
    if (isLoggedIn) {
        return (React.createElement(Button, { ...props, onPress: () => {
                ctx.signOut(redirectUri);
                PlaybackEventEmitter.emit(PlaybackEvent.STOP);
            }, title: "Sign Out" }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ...props, onPress: () => ctx.signIn(redirectUri), title: "Sign In" }),
        regCtx.register && (React.createElement(Button, { type: "clear", title: "or Sign up for free", onPress: () => regCtx.register && regCtx.register() }))));
};
//# sourceMappingURL=LogInLogOutButton.js.map